import axios from 'axios';

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const memberApi = axios.create({
  baseURL: BASE,
  withCredentials: true,
});

let refreshing = null;
memberApi.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    if (error.response?.status === 401 && original && !original._retry) {
      original._retry = true;
      try {
        refreshing = refreshing || axios.post(`${BASE}/auth/refresh`, {}, { withCredentials: true }).finally(() => { refreshing = null; });
        await refreshing;
        return memberApi(original);
      } catch {
        window.location.href = '/account';
      }
    }
    return Promise.reject(error);
  }
);

export const DAY_OPTIONS = [
  { key: 'mon', label: 'Mon' },
  { key: 'tue', label: 'Tue' },
  { key: 'wed', label: 'Wed' },
  { key: 'thu', label: 'Thu' },
  { key: 'fri', label: 'Fri' },
  { key: 'sat', label: 'Sat' },
  { key: 'sun', label: 'Sun' },
];

export const daysummary = (days) =>
  days.length === 7 ? 'Daily' : days.map(d => d.charAt(0).toUpperCase() + d.slice(1)).join(' · ');

export const inputCls = "w-full bg-[#121212] border border-[#27272A] focus:border-[#C41E3A] text-white text-sm px-3 py-2.5 rounded-sm outline-none transition-colors";
